define('formkit/behavior/design.form.root.behavior',['require','exports','module','marionette','./template.object.type.counters.behavior','./design.single.form.object.behavior','./form.condition.map.tracking.behavior'],function(require, exports, module) {
  var Mn                                = require('marionette');
  var TemplateObjectTypeCounterBehavior = require('./template.object.type.counters.behavior');
  var DesignSingleFormObjectBehavior    = require('./design.single.form.object.behavior');
  var FormConditionMapTrackingBehavior  = require('./form.condition.map.tracking.behavior');


  var DesignFormBehavior = Mn.Behavior.extend({

    defaults: {
      form:null
    },

    behaviors: function() {
      return {      
        TemplateObjectTypeCounterBehavior: {
          form: this.getOption('form'),
          behaviorClass: TemplateObjectTypeCounterBehavior
        },
        FormConditionMapTrackingBehavior: {
          form: this.getOption('form'),
          behaviorClass: FormConditionMapTrackingBehavior
        },
        DesignSingleFormObjectBehavior: {
          form: this.getOption('form'),
          behaviorClass: DesignSingleFormObjectBehavior
        }
      }
    }

  });
  module.exports = DesignFormBehavior;
});

